export const demoPageContent={
hero: {
headline: "Real systems. Clear outcomes.",
subheadline: "Short demonstrations showing how websites,dashboards,and automation tools work in practice.",
trustLine: "Sydney-based • Registered business • Practical systems",
primaryCTA: "Browse demonstrations"
},
categories: [
{
id: "automation",
title: "Business Process Automation",
description: "Systems that handle repetitive tasks reliably and reduce manual data handling.",
demos: [
{
id: "demo-smart-forms",
title: "Smart Forms Showcase: Verified Forms for Real Businesses",
category: "automation",
description: "Explore a live library of smart digital forms for intake,consent,bookings,waivers,enquiries and customer workflows,with verification,signatures,and automated notifications built in.",
bullets: [
"Multiple form types already available in one live demo",
"Designed for intake,consent,waivers,bookings,enquiries and service requests",
"Supports email verification,SMS verification and digital signature workflows",
"Helps businesses capture cleaner information and respond faster"
],
tags: ["Smart Forms","Form Library","Verification","Digital Signatures"],
deliverables: ["Live Demo","Multi-Form Showcase","Email + SMS"],
keywords: [
"smart forms",
"form library",
"multiple forms",
"patient intake",
"intake form",
"consent form",
"waiver form",
"booking form",
"enquiry form",
"service request form",
"job application form",
"digital forms",
"paper forms",
"PDF forms",
"email verification",
"sms verification",
"digital signature",
"automated notifications",
"form notifications",
"lead capture",
"customer workflow"
],
liveUrl: "https://app.bpasolutions.au/Smart-forms",
actionLabel: "Open Smart Forms Showcase",
media: [
{
type: "image",
src: "https://cdn1.sharemyimage.com/smi/2026/05/02/Patient-Intake-smart-form.png",
alt: "BPA Solutions Smart Forms Showcase with multiple digital form types,verification,signatures,email and SMS notifications",
watermark: false
}
]
},
{
id: "demo-vector-craft-studio",
title: "Vector Craft Studio",
category: "automation",
description: "Convert images into professional vector graphics,create favicons,and generate branded QR codes with a powerful browser-based design toolkit.",
bullets: [
"Convert PNG and JPG images into scalable SVG vector files",
"Export designs into SVG,EPS,PDF and PNG formats",
"Create website favicons and device-ready icons",
"Generate customised branded QR codes"
],
tags: ["Vector Design","SVG","QR Codes","Favicons","Branding Tools"],
deliverables: ["SVG Export","QR Generator","Favicon Creator"],
keywords: [
"vector converter",
"png to svg",
"jpg to svg",
"svg generator",
"favicon creator",
"qr code generator",
"branding assets",
"graphic design tools"
],
videoUrl: "https://video.bpasolutions.au/video/share/OzuyzxoiWeREzLhO",
actionLabel: "Watch Demo",
media: [
{
type: "image",
src: "https://cloud.sharemyimage.com/2026/07/23/vcs-2.png",
alt: "Vector Craft Studio - browser-based vector design and QR code toolkit",
watermark: false
},
{
type: "video",
src: "https://video.bpasolutions.au/video/share/OzuyzxoiWeREzLhO",
alt: "Vector Craft Studio demo video"
}
]
},
{
id: "demo-bank-extraction",
title: "Bank Statement Extraction",
category: "automation",
description: "Bank statement data extracted and structured for analysis.",
bullets: [
"Clean,structured transaction tables",
"Ready for reconciliation or review",
"Reduced manual handling"
],
tags: ["Automation","Finance","Efficiency"],
deliverables: ["Excel","CSV","Clean Data"],
keywords: ["bank statement","data extraction","pdf parser"],
media: [
{
type: "image",
src: "https://i.ibb.co/JjGB7Lrw/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-10-09-AM-watermarked.png",
alt: "Bank statement data extracted and structured for analysis",
watermark: true
},
{
type: "video",
src: "https://www.youtube.com/embed/dQw4w9WgXcQ"
}
]
},
{
id: "demo-clawback-analysis",
title: "Commission Clawback or Hours Worked Analysis",
category: "automation",
description: "Commission and hours data analysed to identify discrepancies and clawbacks.",
bullets: [
"Discrepancy identification",
"Clawback tracking",
"Time-sheet validation"
],
tags: ["Analysis","Payroll","Compliance"],
deliverables: ["Discrepancy Report","Excel Summary"],
keywords: ["clawback","hours worked","discrepancy"],
media: [
{
type: "image",
src: "https://i.ibb.co/dJQdtQK1/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-06-57-02-AM-watermarked.png",
alt: "Commission and hours data analysed to identify discrepancies and clawbacks",
watermark: true
}
]
},
{
id: "demo-email-signatures",
title: "Generate Professional Email Signatures",
category: "automation",
description: "Professionally designed email signature layouts generated from basic details.",
bullets: [
"Consistent brand identity",
"Automated generation",
"Cross-client compatibility"
],
tags: ["Branding","Utility","Design"],
deliverables: ["HTML Signature","Brand Guide"],
keywords: ["email signature","branding","template"],
media: [
{
type: "image",
src: "https://i.ibb.co/pr3ptCfj/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-41-43-AM-watermarked.png",
alt: "Professionally designed email signature layouts generated from basic details",
watermark: true
}
]
},
{
id: "demo-bulk-certificates",
title: "Bulk Certificate Generation for Courses",
category: "automation",
description: "Automated generation of certificates from structured course data.",
bullets: [
"Instant PDF generation",
"Personalised student data",
"Professional course branding"
],
tags: ["Education","Automation","PDF"],
deliverables: ["PDF Certificates","Email Delivery"],
keywords: ["certificates","bulk generation","course completion"],
media: [
{
type: "image",
src: "https://i.ibb.co/LXNKvvYJ/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-48-52-AM-watermarked.png",
alt: "Automated generation of certificates from structured course data",
watermark: true
}
]
}
]
},
{
id: "analytics",
title: "Insights & Analytics",
description: "Transforming raw data into visual command centers for better decision support.",
demos: [
{
id: "demo-risk-analysis",
title: "Risk Register Analysis and Visualisation",
category: "analytics",
description: "Risk register transformed into prioritised visual insights.",
bullets: [
"Risk prioritisation and heat mapping",
"Category and severity breakdowns",
"Clear focus on high-impact items"
],
tags: ["Risk","Strategy","Insights"],
deliverables: ["Heatmap","Dashboard","PDF Report"],
keywords: ["risk register","visualisation","insights"],
media: [
{
type: "image",
src: "https://i.ibb.co/RTZdYJm4/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-23-55-AM-watermarked.png",
alt: "Risk register transformed into prioritised visual insights",
watermark: true
}
]
},
{
id: "demo-incident-dashboard",
title: "Workplace Incident Reporting Dashboard",
category: "analytics",
description: "Workplace incident data visualised for trend and severity analysis.",
bullets: [
"Safety trend tracking",
"Severity classification",
"Compliance reporting"
],
tags: ["Safety","Operations","Analytics"],
deliverables: ["Safety Dashboard","Trend Report"],
keywords: ["incident report","safety","workplace metrics"],
media: [
{
type: "image",
src: "https://i.ibb.co/RFzRkYn/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-01-14-AM-watermarked.png",
alt: "Workplace incident data visualised for trend and severity analysis",
watermark: true
}
]
},
{
id: "demo-personal-finance",
title: "Personal Finance Overview & Analysis",
category: "analytics",
description: "Personal financial data summarised into a clear analytical overview.",
bullets: [
"Wealth tracking",
"Asset allocation",
"Financial health metrics"
],
tags: ["Finance","Personal","Analysis"],
deliverables: ["Financial Dashboard","Net Worth Tracker"],
keywords: ["personal finance","wealth overview","budget"],
media: [
{
type: "image",
src: "https://i.ibb.co/W42bHhR0/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-04-46-AM-watermarked.png",
alt: "Personal financial data summarised into a clear analytical overview",
watermark: true
}
]
},
{
id: "demo-spending-analysis",
title: "Personal Spending Analysis",
category: "analytics",
description: "Personal spending patterns analysed and categorised visually.",
bullets: [
"Spending habits analysis",
"Category breakdown",
"Saving opportunities"
],
tags: ["Spending","Lifestyle","Budgeting"],
deliverables: ["Spending Report","Categorised Data"],
keywords: ["spending analysis","budgeting","expense tracking"],
media: [
{
type: "image",
src: "https://i.ibb.co/JFqcngKp/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-14-39-AM-watermarked.png",
alt: "Personal spending patterns analysed and categorised visually",
watermark: true
}
]
},
{
id: "demo-sales-commission",
title: "Sales Commission Dashboard",
category: "analytics",
description: "Sales commission performance summarised in an executive dashboard.",
bullets: [
"Performance tracking",
"Payout summaries",
"KPI visualisations"
],
tags: ["Sales","Commission","Performance"],
deliverables: ["Executive Dashboard","Payout Report"],
keywords: ["sales dashboard","commission tracker","payouts"],
media: [
{
type: "image",
src: "https://i.ibb.co/Z1bN8nFH/BPA-Solutions-Services-Chat-GPT-Image-Feb-8-2026-07-29-12-AM-watermarked.png",
alt: "Sales commission performance summarised in an executive dashboard",
watermark: true
}
]
}
]
}
],
dueDiligence: {
heading: "Built for due diligence",
text: [
"These demonstrations exist to remove ambiguity.",
"They show real inputs,real processing,and real outputs - without sales talk or assumptions.",
"Each example is a starting point and can be adapted to different businesses,scopes,and budgets."
]
},
closingCTA: {
heading: "Not sure which demonstration is relevant?",
primaryButton: "Send your requirement",
secondaryButton: "Book a quick 15-minute call"
}
};